function salbaMouseOver(x){
    if (!x || !x.parentElement) return; // Safety check
    let nodd = x.parentElement;
    nodd.setAttribute('megaopen', true);
}

function salbaMouseOut(x){
    if (!x || !x.parentElement) return; // Safety check
    let nodd = x.parentElement;
    nodd.removeAttribute('megaopen');
}

// Menu Logic - Preserved
document.addEventListener("DOMContentLoaded", () => {
    const menu = document.querySelector(".salba_header__inline-menu");
    
    if (menu) {
        var items = menu.querySelectorAll("details");
        items.forEach(item => {        
            item.addEventListener("mouseover", () => {
                item.setAttribute("open", true);
                const ul = item.querySelector("ul");
                if (ul) {
                    ul.addEventListener("mouseleave", () => {
                        setTimeout(function(){
                            if(item.hasAttribute('megaopen')){
                                item.setAttribute("open", true);
                            }else{
                                item.removeAttribute("open");
                            }
                        }, 500);
                    });
                }
                
                item.addEventListener("mouseleave", () => {
                    setTimeout(function(){
                        if(item.hasAttribute('megaopen')){
                            item.setAttribute("open", true); 
                        }else{
                            item.removeAttribute("open");
                        }
                    }, 100);
                });
            }); 
        });
    }
});

/* -------------------------------------------------------
   REMOVED: Old 'fetchABSLogin' function
   REMOVED: Old jQuery '#abs-login-button' click handler
   REMOVED: Old Shadow DOM Observer logic
   
   These are now handled exclusively by the new Dealer Bar section.
   -------------------------------------------------------
*/